export const ClubLogo = ({ size = 40, className = "" }) => (
  <span
    className={`inline-flex items-center justify-center rounded-full bg-white overflow-hidden shrink-0 ring-1 ring-[#E5AC3C]/50 ${className}`}
    style={{ width: size, height: size }}
    data-testid="club-logo"
  >
    <img
      src="/assets/logo-centenary.jpg"
      alt="Whitley Bay Cricket Club centenary logo 1926-2026"
      className="w-full h-full object-cover"
    />
  </span>
);
